import React from 'react';
import { useAuth } from '../firebase/AuthContext';
import { logOut } from '../firebase/auth';
import { useNavigate } from 'react-router-dom';
 
function PaywallScreen({ reason }) {
  const { orgData } = useAuth();
  const navigate = useNavigate();
 
  const handleSignOut = async () => {
    await logOut();
    navigate('/login');
  };
 
  const isTrialExpired = reason === 'trial';
 
  return (
    <div style={styles.page}>
      <div style={styles.card}>
 
        {/* Header */}
        <div style={styles.logoRow}>
          <div style={styles.logo}>M<span style={styles.logoBlue}>I</span>A</div>
        </div>
 
        <div style={styles.icon}>{isTrialExpired ? '⏱' : '⚠'}</div>
 
        <div style={styles.title}>
          {isTrialExpired ? 'Your 30-day trial has ended.' : 'Your account is no longer active.'}
        </div>
 
        <div style={styles.msg}>
          {isTrialExpired
            ? 'You had full access during your trial. To keep using MIA, choose a plan that fits your shop.'
            : 'Your MIA subscription is no longer active. Reach out to reactivate your account and pick up right where you left off.'}
        </div>
 
        {orgData?.serialNumber && (
          <div style={styles.serial}>
            Account serial: <strong>{orgData.serialNumber}</strong>
          </div>
        )}
 
        {/* Pricing cards */}
        {isTrialExpired && (
          <div style={styles.plans}>
            <div style={styles.plan}>
              <div style={styles.planName}>Solo</div>
              <div style={styles.planPrice}>$34.99<span style={styles.planPer}>/mo</span></div>
              <div style={styles.planDesc}>1 user · full access</div>
            </div>
            <div style={{ ...styles.plan, ...styles.planFeatured }}>
              <div style={styles.planBadge}>Most Popular</div>
              <div style={{ ...styles.planName, color: '#fff' }}>Pro</div>
              <div style={{ ...styles.planPrice, color: '#fff' }}>$199<span style={{ ...styles.planPer, color: 'rgba(255,255,255,0.5)' }}>/mo</span></div>
              <div style={{ ...styles.planDesc, color: 'rgba(255,255,255,0.55)' }}>Unlimited users · flat rate</div>
            </div>
            <div style={styles.plan}>
              <div style={styles.planName}>MIA Local</div>
              <div style={styles.planPrice}>$299<span style={styles.planPer}>/mo</span></div>
              <div style={styles.planDesc}>Offline · air-gapped</div>
            </div>
          </div>
        )}
 
        {/* CTA */}
        <a
          href={`mailto:JimmyKDiaz@gmail.com?subject=MIA Subscription - ${orgData?.serialNumber || 'Account'}&body=Hi, I'd like to continue using MIA. My account serial is ${orgData?.serialNumber || 'N/A'}.`}
          style={styles.ctaBtn}
        >
          Contact us to continue →
        </a>
 
        <div style={styles.contactRow}>
          <span style={styles.contactItem}>📞 580-789-1665</span>
          <span style={styles.contactItem}>✉ JimmyKDiaz@gmail.com</span>
        </div>
 
        <button style={styles.signOutBtn} onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
 
const styles = {
  page: {
    display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center',
    background: '#f0f2f5', fontFamily: 'Inter, sans-serif', padding: '20px',
  },
  card: {
    background: '#fff', borderRadius: '16px', border: '1px solid #e5e7eb',
    padding: '40px 36px', maxWidth: '560px', width: '100%', textAlign: 'center',
  },
  logoRow: { marginBottom: '24px' },
  logo: { fontSize: '32px', fontWeight: '800', color: '#0d1b2a', letterSpacing: '-1px' },
  logoBlue: { color: '#378ADD' },
  icon: { fontSize: '40px', marginBottom: '16px' },
  title: { fontSize: '20px', fontWeight: '700', color: '#111827', marginBottom: '12px', lineHeight: '1.3' },
  msg: { fontSize: '14px', color: '#6b7280', lineHeight: '1.65', marginBottom: '16px', maxWidth: '420px', margin: '0 auto 16px' },
  serial: { fontSize: '12px', color: '#9ca3af', marginBottom: '28px', fontFamily: 'monospace' },
 
  // Pricing cards
  plans: { display: 'flex', gap: '12px', marginBottom: '28px', marginTop: '8px' },
  plan: {
    flex: 1, border: '1px solid #e5e7eb', borderRadius: '10px',
    padding: '16px 12px', textAlign: 'center', background: '#fff',
  },
  planFeatured: { background: '#0d1b2a', border: '1px solid #378ADD' },
  planBadge: {
    fontSize: '9px', fontWeight: '700', letterSpacing: '0.12em',
    textTransform: 'uppercase', color: '#6FB1EA',
    marginBottom: '8px',
  },
  planName: { fontSize: '13px', fontWeight: '600', color: '#111827', marginBottom: '6px' },
  planPrice: { fontSize: '22px', fontWeight: '800', color: '#111827', lineHeight: '1' },
  planPer: { fontSize: '12px', fontWeight: '400', color: '#9ca3af' },
  planDesc: { fontSize: '11px', color: '#9ca3af', marginTop: '4px', lineHeight: '1.4' },
 
  // CTA
  ctaBtn: {
    display: 'block', background: '#2563EB', color: '#fff',
    borderRadius: '10px', padding: '13px 24px',
    fontSize: '14px', fontWeight: '600', textDecoration: 'none',
    marginBottom: '16px',
  },
  contactRow: {
    display: 'flex', justifyContent: 'center', gap: '20px',
    fontSize: '12.5px', color: '#6b7280', marginBottom: '24px', flexWrap: 'wrap',
  },
  contactItem: { display: 'flex', alignItems: 'center', gap: '6px' },
  signOutBtn: {
    background: 'transparent', border: '1px solid #e5e7eb', borderRadius: '8px',
    padding: '8px 20px', fontSize: '13px', color: '#9ca3af',
    cursor: 'pointer', fontFamily: 'inherit',
  },
};
 
export default PaywallScreen;